import { z } from "zod/v4";
import {
	type CourtAvailSlotInput,
	courtAvailSourceInsightSchema,
	courtAvailSourceSlotsSchema,
	courtAvailSyncOutcomeSchema,
	courtAvailSyncResultSchema,
	type CreateCourtAvailSource,
	createCourtAvailSourceResultSchema,
	ingestCourtSlotsResultSchema,
	type UpdateCourtAvailSource,
	updateCourtAvailSourceResultSchema,
} from "../schemas/court-availability";
import { fetchApi, fetchVoid } from "./internal";

// Court-availability sources are a sub-resource of locations: the location
// service serves them under the same /admin/locations group.
const SOURCES = "/admin/locations/sources";

export const courtAvailability = {
	listSources: () => fetchApi(SOURCES, z.array(courtAvailSourceInsightSchema)),
	createSource: (data: CreateCourtAvailSource) =>
		fetchApi(SOURCES, createCourtAvailSourceResultSchema, {
			body: JSON.stringify(data),
			method: "POST",
		}),
	updateSource: (sourceId: string, data: UpdateCourtAvailSource) =>
		fetchApi(`${SOURCES}/${sourceId}`, updateCourtAvailSourceResultSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
	deleteSource: (sourceId: string) => fetchVoid(`${SOURCES}/${sourceId}`, { method: "DELETE" }),
	listSlots: (sourceId: string) =>
		fetchApi(`${SOURCES}/${sourceId}/slots`, courtAvailSourceSlotsSchema),
	ingestSlots: (sourceId: string, slots: CourtAvailSlotInput[]) =>
		fetchApi(`${SOURCES}/${sourceId}/slots`, ingestCourtSlotsResultSchema, {
			body: JSON.stringify({ slots }),
			method: "POST",
		}),
	syncSource: (sourceId: string) =>
		fetchApi(`${SOURCES}/${sourceId}/syncs`, courtAvailSyncOutcomeSchema, { method: "POST" }),
	triggerSync: () =>
		fetchApi(`${SOURCES}/syncs`, courtAvailSyncResultSchema, { method: "POST" }),
};
